export default __webpack_public_path__ + "static/media/190629_190332_IMG_6004.ddc5d748.jpg";